export default __webpack_public_path__ + "static/media/ca.314f8d47.svg";